import * as React from "react";
const InvalidCallIcon = (props) => (
  <svg
    width={46}
    height={45}
    viewBox="0 0 46 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.666992} width={45} height={45} rx={6} fill="#8b58f1" />
    <g clipPath="url(#clip0_43824_67461)">
      <path
        d="M33.667 27.6567V31.782C33.6671 32.0774 33.5552 32.3618 33.3538 32.5779C33.1525 32.794 32.8766 32.9257 32.582 32.9463C32.0722 32.9813 31.6557 33 31.3337 33C21.0238 33 12.667 24.6432 12.667 14.3333C12.667 14.0113 12.6845 13.5948 12.7207 13.085C12.7413 12.7904 12.873 12.5145 13.0891 12.3131C13.3052 12.1118 13.5896 11.9999 13.885 12H18.0103C18.155 11.9999 18.2946 12.0535 18.402 12.1505C18.5094 12.2475 18.5769 12.381 18.5913 12.525C18.6182 12.7933 18.6427 13.0068 18.666 13.169C18.8978 14.7871 19.373 16.3608 20.0753 17.8368C20.1862 18.0702 20.1138 18.349 19.9038 18.4983L17.3862 20.2973C18.9255 23.8842 21.784 26.7426 25.3708 28.282L27.1675 25.769C27.2409 25.6663 27.3481 25.5927 27.4702 25.5609C27.5924 25.5292 27.7218 25.5413 27.836 25.5952C29.3119 26.2962 30.8852 26.7701 32.5027 27.001C32.6648 27.0243 32.8783 27.05 33.1443 27.0757C33.2881 27.0904 33.4213 27.158 33.5181 27.2653C33.6148 27.3727 33.6683 27.5121 33.6682 27.6567H33.667Z"
        fill="white"
      />
      <g clipPath="url(#clip1_43824_67461)">
        <rect x={24} y={12} width={10} height={10} rx={5} fill="white" />
        <path d="M19.25 26.75L38.75 7.25" stroke="#8b58f1" />
      </g>
      <rect x={24.5} y={12.5} width={9} height={9} rx={4.5} stroke="white" />
    </g>
    <defs>
      <clipPath id="clip0_43824_67461">
        <rect
          width={28}
          height={28}
          fill="white"
          transform="translate(9.16699 8.5)"
        />
      </clipPath>
      <clipPath id="clip1_43824_67461">
        <rect x={24} y={12} width={10} height={10} rx={5} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default InvalidCallIcon;
